import {UIProfileSettingsController} from '../../../../../../shared/scripts/profile/UIProfileSettingsController'
import {UIMDeviceInfoPopup} from '../../../../ui_popup/UIMDeviceInfoPopup'
import {ViewPopupEditProfile} from '../../../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {UIMProfileUsernameController} from '../UIMProfileUsernameController'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils'

export class UIMProfileSettingsController extends UIProfileSettingsController {
    private readonly editProfileButton: HTMLButtonElement

    constructor() {
        super()
        this.editProfileButton = document.getElementById('m-edit-profile') as HTMLButtonElement
        setElementOnClick(this.editProfileButton, () => {
            new ViewPopupEditProfile({
                usernameController: UIMProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
            })
        })

        const deviceInfoButton = document.getElementById('m-debug-info') as HTMLButtonElement
        setElementOnClick(deviceInfoButton, () => new UIMDeviceInfoPopup().show())
    }
}
